import React, { useState } from "react";
import api, { formatApiError } from "@/lib/upr-api";
import { toast } from "sonner";
import { Bell, Check, X } from "lucide-react";

/**
 * Inline "Notify me when back in stock" widget for sold-out merch.
 */
export default function NotifyMeButton({ merchId, testid = "notify" }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBusy(true);
    try {
      await api.post(`/merch/${merchId}/notify-me`, { email });
      setDone(true);
      toast.success("We'll email you the moment it's back.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not register.");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <span className="upr-eyebrow inline-flex items-center gap-1" style={{ color: "var(--upr-secondary)" }} data-testid={`${testid}-${merchId}-done`}>
        <Check size={12} /> You&apos;re on the list
      </span>
    );
  }

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="upr-link-underline text-xs font-heading uppercase tracking-widest inline-flex items-center gap-1"
        data-testid={`${testid}-${merchId}-open`}
      >
        <Bell size={12} /> Notify me
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="flex items-stretch gap-1" data-testid={`${testid}-${merchId}-form`}>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`${testid}-${merchId}-email`}
        className="px-2 py-1 bg-transparent border text-xs focus:outline-none focus:border-[color:var(--upr-primary)]"
        style={{ borderColor: "var(--upr-border)", width: 150 }}
      />
      <button type="submit" disabled={busy} className="upr-btn text-xs" data-testid={`${testid}-${merchId}-submit`} style={{ padding: "0.35rem 0.7rem" }}>
        {busy ? "…" : "OK"}
      </button>
      <button type="button" onClick={() => setOpen(false)} className="upr-btn upr-btn-ghost" style={{ padding: "0.35rem 0.5rem" }} aria-label="Cancel"><X size={12} /></button>
    </form>
  );
}
